/**
 * Theme configuration utility.
 *
 * Resolves the active theme based on the VITE_ON4U_API_ORIGIN_VALUE env variable.
 * - 'b2b.vtrshoes.com'           → vtr-theme
 * - Any other value (default)    → cnmv-theme
 *
 * For build-time resolution (vite.config.js) use getThemeName() directly.
 * For runtime resolution (Vue components) use the THEME_NAME constant.
 */

const VTR_ORIGIN = 'b2b.vtrshoes.com';
const VTR_THEME = 'vtr-theme';
const CNMV_THEME = 'cnmv-theme';

/**
 * Returns the active theme name based on the env variable.
 * Works both at build-time (Node) and at runtime (browser via import.meta.env).
 */
export function getThemeName(originValue) {
    return originValue === VTR_ORIGIN ? VTR_THEME : CNMV_THEME;
}

/**
 * Active theme name resolved at runtime from Vite env injection.
 */
export const THEME_NAME = getThemeName(import.meta.env.VITE_ON4U_API_ORIGIN_VALUE);

/**
 * Whether the current theme is VTR.
 */
export const IS_VTR_THEME = THEME_NAME === VTR_THEME;

/**
 * Whether the current theme is CNMV (Calzados Nueva Milenio Victoria).
 */
export const IS_CNMV_THEME = THEME_NAME === CNMV_THEME;

export const IS_BACKGROUND_DARK = IS_VTR_THEME;
